import React from 'react';
import Immutable from 'immutable';

import { Node, useViewFilterQuery } from '@uncinc/react-drupal-core';
import { ImmutableEntity, Pager as PageType } from '@uncinc/react-drupal-core/types';

import { NodeVacancy } from '../../../types/uncinc_profile/nodes';

import './style.scss';
import { Pager } from '../../../components';

interface ViewVacancyOverviewProps {
  entities: Immutable.List<ImmutableEntity<NodeVacancy>>;
  pager: Immutable.List<ImmutableEntity<PageType>>;
}

const ViewVacanciesFiltered: React.FC<ViewVacancyOverviewProps> = ({
  entities, pager,
}) => {
  const totalPages = Number(pager.getIn(['total_pages']));
  const { page, setCurrentPage } = useViewFilterQuery();
  const currentPage: number = Number(page) + 1;

  return (
    <div className="ViewVacanciesOverview">
      <div className="row">
        {entities.map((entity) => {
          const vacancy = entity.toJS();

          const uuid = vacancy.uuid[0].value;
          const langcode = vacancy.langcode[0].value;
          const key = `${uuid}:${langcode}`;

          return (
            <div key={key} className="col-12 col-lg-6">
              <Node
                entity={entity}
                viewMode="teaser"
              />
            </div>
          );
        })}
      </div>
      <div className="ViewArticlesFiltered__pager">
        <Pager
          totalPages={totalPages}
          setCurrentPage={setCurrentPage}
          currentPage={currentPage}
        />
      </div>
    </div>
  );
};
export default ViewVacanciesFiltered;
